module.exports = __webpack_public_path__ + "static/img/71_Christmas tree.5d3fcf56.jpg";